import { request } from './client';

export const docusignService = {
  getDocuSignSettings: async () => {
    try {
      return await request('/docusign/settings');
    } catch (error) {
      console.warn("Could not fetch DocuSign settings", error);
      return null;
    }
  },

  saveDocuSignSettings: (config) => request('/docusign/settings', { method: 'POST', body: config }),

  getDocuSignTemplates: () => request('/docusign/templates'),

  sendDocuSignEnvelope: (data) => request('/docusign/send', { method: 'POST', body: data }),
};
